import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "card mb-6 mb-xl-9",
  style: {"height":"70vh"}
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "My Conflicts", -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "card-body card-scroll h-250px p-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-calendar-circle-minus fa-4x" }, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_8 = {
  class: "table table-flush align-middle table-row-bordered table-row-solid gy-4 gs-9",
  "aria-label": "A list of all your scheduling conflicts."
}
const _hoisted_9 = { class: "fw-6 fw-bold text-gray-600" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "mb-1 text-white text-hover-primary" }
const _hoisted_12 = { class: "fw-bold fs-6 text-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-primary btn-sm",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.invokeAddConflict && _ctx.invokeAddConflict(...args)))
        }, "Add Conflict ")
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.upcomingConflicts.length === 0)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            description: "No Upcoming Conflicts"
          }, {
            image: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _withDirectives((_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upcomingConflicts, (conflict) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: conflict.conflictId
                  }, [
                    _createElementVNode("td", {
                      onClick: ($event: any) => (_ctx.invokeUpdateConflict(conflict)),
                      class: "cursor-pointer"
                    }, [
                      _createElementVNode("a", _hoisted_11, _toDisplayString(conflict.name), 1),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.formatDate(conflict)), 1)
                    ], 8, _hoisted_10)
                  ]))
                }), 128))
              ])), [
                [_directive_loading, _ctx.isFetching]
              ])
            ])
          ]))
    ])
  ]))
}